import { Modal } from "react-bootstrap";
import backIcon from "../../../../images/arrow-left-solid.png";
import placeholderImage from "../../../../images/placeholder-image.png";
import *  as CommonUtilities from "../../../../common/utils/CommonUtils.js";
import defaultImage from "../../../../images/default.jpg";
import ErrorAlert from "../../../../common/ui/ErrorAlert";

export default function ItemVoucherChildPage(props) {
    let selectedProductID = props.loyaltyMember.ItemVoucherChildPage.SelectedProduct.ProductID;
    let chargePriceForMods = props.loyaltyMember.ItemVoucherChildPage.SelectedProduct.ChargePriceForMods;
    let formData = props.loyaltyMember.ItemVoucherChildPage.FormData.ModifierCategories;
    let voucherMenuNumber = `voucherMenu${props.loyaltyMember.ItemVoucherProductListPage.SelectedGroup.VoucherMenuNumber}`;
    let groupDetails = props.loyaltyMember.VoucherDetails.OriginalData[voucherMenuNumber][0];
    let productsInGroup = groupDetails.products;

    // Product Details
    let productDetails = productsInGroup.find(({productID}) => productID == selectedProductID);

    // Is Disabled
    let isDisabled = props.loyaltyMember.ItemVoucherChildPage.GeneralError.ButtonsDisabled || !props.currentLocation.AllowOnlineOrder || !props.currentLocation.Validation.IsValidTableNumber;
    let isDisabledCursor = isDisabled ? "default" : "pointer";

    // Energy Count
    let energyCount;
    if (productDetails.energyCount !== 0 && productDetails.energyCount !== "0" && productDetails.energyCount !== "" && productDetails.energyCount !== null) {
        energyCount = <span className="badge bg-secondary bg-opacity-50">{productDetails.energyCount}kJ</span>
    } else {
        energyCount = <></>
    }

    // Modifier Categories
    let modifierCategories, modifiers;
    modifierCategories = productDetails.modeCategories?.map((modCat) => {

        // Choose Amount - Text
        let badgeClassStyles = "";
        let chooseAmountText = "";
        if (modCat.minValue == 0) {
            chooseAmountText = `Choose up to ${modCat.maxValue}`
        } else if (modCat.minValue == modCat.maxValue) {
            chooseAmountText = `Choose ${modCat.maxValue}`
        } else {
            chooseAmountText = `Choose between ${modCat.minValue} - ${modCat.maxValue}`
        }

        // Modifiers
        modifiers = modCat.mods?.map((mod, index) => {
            let modifierPriceInc = chargePriceForMods ? CommonUtilities.formatDisplayPrice(mod.priceInc) : '';
            let modifierLabel;
            let priceLabel;
            let modifierSelector;
            
            if (modCat.type === "Check") { // Check
                // Find Modifier Category
                let formDataModCat = formData.find((modCatFieldName) => modCatFieldName.ModCatFieldName == `CheckModCatId${modCat.modCategoryID}`);
                // Badge for Choose Text
                if (formDataModCat.HasError) {
                    badgeClassStyles = "text-bg-danger";
                } else {
                    badgeClassStyles = "text-bg-light badgeLight";
                }
                // Form Data - Check
                let modFormData = formDataModCat.Mods.find((modFieldName) => modFieldName.ModFieldName == `CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`);
                // Label, Price and Selector
                modifierLabel = <label className="form-check-label col" htmlFor={`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`} style={{cursor: isDisabledCursor}}>{mod.modName}</label>
                priceLabel = <label className="ms-1 me-4 form-check-label" htmlFor={`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`} style={{cursor: isDisabledCursor}}>{modifierPriceInc}</label>
                modifierSelector = <div className="form-check ms-1">
                                        <input className="form-check-input" type="checkbox" value="" data-modplu={mod.modPLUNumberInt} data-priceinc={mod.priceInc} data-modcat={`CheckModCatId${modCat.modCategoryID}`} data-modname={mod.modName} name={`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`} id={`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`} checked={modFormData[`CheckModCatId${modCat.modCategoryID}ModId${mod.modID}`]} onChange={props.handleModChangeItemVoucherChild} disabled={isDisabled} style={{cursor: isDisabledCursor}} />
                                    </div>
            } else if (modCat.type === "Radio") { // Radio
                // Find Modifier Category
                let formDataModCat = formData.find((modCatFieldName) => modCatFieldName.ModCatFieldName == `RadioModCatId${modCat.modCategoryID}`);
                // Badge for Choose Text
                if (formDataModCat.HasError) {
                    badgeClassStyles = "text-bg-danger";
                } else {
                    badgeClassStyles = "text-bg-light badgeLight";
                }
                // Form Data - Radio
                let modFormData = formDataModCat.Mods.find((modFieldName) => modFieldName.ModFieldName == `RadioModCatId${modCat.modCategoryID}`);
                // Label, Price and Selector
                modifierLabel = <label className="form-check-label col" htmlFor={`RadioModCatId${modCat.modCategoryID}ModId${mod.modID}`} style={{cursor: isDisabledCursor}}>{mod.modName}</label>
                priceLabel = <label className="ms-1 me-4 form-check-label" htmlFor={`RadioModCatId${modCat.modCategoryID}ModId${mod.modID}`} style={{cursor: isDisabledCursor}}>{modifierPriceInc}</label>
                modifierSelector = <div className="form-check ms-1">
                                        <input type="radio" value={mod.modID} data-modplu={mod.modPLUNumberInt} data-priceinc={mod.priceInc} data-modcat={`RadioModCatId${modCat.modCategoryID}`} data-modname={mod.modName} name={`RadioModCatId${modCat.modCategoryID}`} id={`RadioModCatId${modCat.modCategoryID}ModId${mod.modID}`} checked={modFormData[`RadioModCatId${modCat.modCategoryID}`] == mod.modID} onChange={props.handleModChangeItemVoucherChild} disabled={isDisabled} style={{cursor: isDisabledCursor}} />
                                    </div>
            }

            return ( // Modifiers
                <div key={mod.modID} className="col-12 d-flex justify-content-between py-2 align-items-center">
                    {CommonUtilities.StaticFields.ShowModifierImages ? 
                    <div className="me-3">
                        <img src={mod.modImageURL ? mod.modImageURL : defaultImage} className="rounded-3 w-100 shadow-sm" style={{objectFit: "cover", objectPosition: "center center", aspectRatio: "1/1", maxWidth: "70px", minWidth: "70px"}} alt="Modifier"></img>
                    </div>
                    : <></>}
                    {modifierLabel}
                    <div className="d-flex justify-content-between">
                        {mod.priceInc != 0 && priceLabel}
                        {modifierSelector}
                    </div>
                </div>
            )
        })

        return ( // Modifier Categories
            <div key={modCat.modCategoryID}>
                <div className="col-12">
                    <hr className="text-body-tertiary"/>
                </div>
                <div className="col-12 d-flex justify-content-between pb-1">
                    <b>{modCat.modCategoryName}</b>
                    {modCat.maxValue && <span className={`badge ${badgeClassStyles}`}>{chooseAmountText}</span>}
                </div>
                {modifiers}
            </div>
        )
    })

    return (
        <>
            <div className="modal-header justify-content-start">
                <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackItemVoucherChild} disabled={props.loyaltyMember.ItemVoucherChildPage.GeneralError.ButtonsDisabled} >
                    <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                </button>
                <h1 className="modal-title fs-5 text-break">&emsp;Select Voucher Details</h1>
                <button type="button" className="btn-close" aria-label="Close" onClick={props.handleClickCloseLoyaltyModal}></button>
            </div>
            <Modal.Body>
                <div className="row">
                    <div className="col-4">
                        <img src={productDetails.productImageURL ? productDetails.productImageURL : placeholderImage} className="rounded-3 float-end my-2 w-100 shadow-sm" style={{objectFit: "cover", objectPosition: "center center", aspectRatio: "1/1", maxWidth: "300px", minWidth: "70px"}} alt="Product"></img>
                    </div>
                    <div className="col-8 d-flex flex-column justify-content-between">
                        <div className="d-flex flex-column text-break">
                            <div>
                                <b className="me-2">{productDetails.productDisplayName}</b>{energyCount}
                            </div>
                        </div>
                    </div>
                    {modifierCategories}
                </div>
            </Modal.Body>
            <Modal.Footer>
                { props.loyaltyMember.ItemVoucherChildPage.GeneralError.HasError && <div className="px-1 mx-auto mb-3 col-12"><ErrorAlert message={props.loyaltyMember.ItemVoucherChildPage.GeneralError.ErrorMessage} /></div> }
                    {props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && 
                    <div className="col-12 d-flex justify-content-center mx-auto">
                        <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleAddToVoucherItemVoucherChild} disabled={props.loyaltyMember.ItemVoucherChildPage.GeneralError.ButtonsDisabled} >
                            Add to Voucher
                            { props.loyaltyMember.ItemVoucherChildPage.GeneralError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></>}
                        </button>
                    </div>}
            </Modal.Footer>
        </>
    )
}